export default "__VITE_ASSET__Dncx2aLF__"